import { AppTreeSide, UniDateRangePicker } from 'components'
import ssoLoginMixin from '@/mixins/sso-login-mixin.js' // 引入mixin文件
import convertorMixin from '@/mixins/convertor-mixin.js' // 引入mixin文件
import idNameMixin from '@/mixins/id-name-mixin.js' // 引入mixin文件
import {getRegionList} from '@/api/get-data.js'
import {loadRegionTree} from '@/utils/tree'
import {getOneWeekBeginAndEndDate} from '@/utils/date'
import {getDepartmentList} from '@/api/get-data'
import {getNameById} from '@/utils/public'

export default {
  name: 'PersonalAccessRecords',
  data () {
    return {
      // 侧边栏打开标志
      treeSideBarOpen: true,
      // 树数据
      treeData: [],
      treeExpandedKeys: [], // 默认展开树节点key
      // 树查询条件
      treeQueryParams: {
        pageNum: 1,
        pageSize: 1000
      },
      // 默认树属性
      defaultTreeProps: {
        label: 'name' // name字段作为label
      },
      // 树节点显示过滤
      treeNodeFilter: '',
      filteredTreeData: [],
      // 活动页面索引
      activeTabName: '0',
      // 遮罩层
      loading: false,
      // 事件记录页面--------------------------------------------------------------------------------------------------
      // 表格数据
      eventTableData: [],
      eventTableTotalRow: 0,
      // 表格查询条件
      eventDates: [], // 查询起始和结束日期
      eventTableQueryParams: {
        lastEventId: 0,
        regionId: -1,
        objectId: 0,
        descendantRegionRequired: 1,
        resourceKind: 22, // 信号量输入
        resourceSubType: 5, // 门
        systemKind: 0,
        alarmStates: [],
        beginHappenDateTime: 0,
        endHappenDateTime: 0,
        handleStates: [], // 处理状态数组
        orderBy: 1, // 排序方式,0-增序，1-减序
        pageNum: 1,
        pageSize: 15
      },
      // 表格选中记录数组
      eventTableSelectedIds: [],
      // 事件表格当前行
      eventTableCurrentRow: null,
      // 事件信息弹窗
      showEventModalOpen: false,
      // 轮巡定时器
      pollingTimer: null
    }
  },
  components: {
    AppTreeSide,
    UniDateRangePicker
  },
  mixins: [
    ssoLoginMixin,
    convertorMixin,
    idNameMixin
  ],
  watch: {
    // 根据名称筛选节点
    treeNodeFilter(val) {
      this.$refs.tree.filter(val.trim())
    }
  },
  mounted () {
    // 设置查询起始日期和截止日期
    this.eventDates = getOneWeekBeginAndEndDate() // 近一周

    // 单点登录（如url包含code和uiapTpye参数则启用单点登录）
    this.ssoLogin(this.$route.query.code, this.$route.query.uiapType).then(res => {
      // 获取部门列表
      getDepartmentList(() => {
        // 获取区域列表
        this.getRegionList2()
      })
    })
  },
  methods: {
    // 显示或隐藏树侧边栏
    toggleTreeSideBar() {
      this.treeSideBarOpen = !this.treeSideBarOpen
    },
    // 查询区域列表
    getRegionList2() {
      this.loading = true
      getRegionList(this.$globalConfig.regionGettingFilterMode, () => {
        this.loading = false
        this.treeData = []
        this.treeData = loadRegionTree(this.$globalData.regions, this.treeData)
        this.$nextTick(() => {
          if (this.treeData.length) {
            // 默认展开根节点
            this.treeExpandedKeys = [this.treeData[0].key]
            // 设置根节点为当前节点
            this.$refs.tree.setCurrentKey(this.treeData[0].key)
            // 单击当前节点
            this.handleTreeNodeClick(this.$refs.tree.getCurrentNode())
          }
        })
      })
    },
    // 查询事件列表
    getHistoryEventList() {
      this.loading = true
      this.eventTableQueryParams.beginHappenDateTime = this.eventDates[0].getTime() / 1000
      this.eventTableQueryParams.endHappenDateTime = this.eventDates[1].getTime() / 1000
      this.$http(this.$api.historyEventList, this.eventTableQueryParams).then(
        res => {
          if (res.code === 200) {
            res.data.forEach(item => {
              item.departmentName = getNameById(this.$globalData.departments, item.personId) // 返回部门名称
            })
            this.eventTableData = res.data
            this.eventTableTotalRow = res.page.totalRow
          }
          this.loading = false
        }
      ).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 过滤树节点
    filterTreeNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 单击树节点
    handleTreeNodeClick(obj) {
      if (this.activeTabName === '0') {
        if (this.eventTableQueryParams.regionId !== obj.id) {
          this.eventTableQueryParams.regionId = obj.id
          this.eventTableQueryParams.pageNum = 1
          this.getHistoryEventList()
        }
      }
    },
    // tab页面切换
    handleTabClick(tab) {
      let currentNode = this.$refs.tree.getCurrentNode()
      if (currentNode) {
        this.handleTreeNodeClick(currentNode)
      }
    },
    // 事件记录页面------------------------------------------------------------------------------------------------
    // 查询按钮操作
    handleEventFormQuery() {
      this.eventTableQueryParams.page = 1
      this.getHistoryEventList()
    },
    // 重置按钮操作
    resetEventQueryForm() {
      this.eventTableQueryParams.regionId = 0
      this.eventTableQueryParams.objectId = 0
      this.eventTableQueryParams.descendantRegionRequired = 1
      this.eventTableQueryParams.resourceKind = 22
      this.eventTableQueryParams.resourceSubType = 5
      this.eventTableQueryParams.alarmStates = []
      this.eventDates = getOneWeekBeginAndEndDate() // 近一周
      this.eventTableQueryParams.beginHappenDateTime = 0
      this.eventTableQueryParams.endHappenDateTime = 0
      this.eventTableQueryParams.handleStates = []
      this.eventTableQueryParams.pageNum = 1
      this.$refs['eventQueryForm'].resetFields()
      this.handleEventFormQuery()
    },
    // 分页
    handleEventCurrentPageChange(val) {
      this.eventTableQueryParams.pageNum = val
      this.getHistoryEventList()
    },
    // 页面条数改变
    handleEventPageSizeChange(val) {
      this.eventTableQueryParams.pageSize = val
      this.getHistoryEventList()
    },
    // 表格选中记录改变
    handleEventTableSelectionChange(selection) {
      this.eventTableSelectedIds = selection.map(item => item.id)
    },
    // 查看事件
    handleEventView(row) {
      if (row && row.id) {
        this.$refs.eventTable.setCurrentRow(row) // 选中当前行
        this.showEventModalOpen = true
      }
    },
    // 处理事件
    handleEventHandle() {

    }
  }
}



// WEBPACK FOOTER //
// ./src/views/events/PersonalAccessRecords/PersonalAccessRecords.js